import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

import { Observable, of } from 'rxjs';

import { ToastStatus, UtilsService } from '../../utils.service';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor(private utilsService: UtilsService) { }

  private part1Data: any = null;

  private removeEspaces(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.controls[key];
      if (control instanceof FormGroup) {
        this.removeEspaces(control);
      } else if (control.value && typeof control.value === 'string') {
        control.setValue(control.value.trim());
      }
    });
  }

  public validateForm(form: FormGroup, label: Record<string, string>): boolean {
    this.removeEspaces(form);

    if (form.valid) {
      return true;
    }

    for (const key in form.controls) {
      const control = form.controls[key];
      const fieldName = label[key] || key;

      if (control.errors) {
        if (control.errors['required']) {
          this.utilsService.toast(
            `O campo ${fieldName} é obrigatório!`,
            ToastStatus.Error
          );
        } else {
          this.utilsService.toast(
            `O campo de ${fieldName} está inválido!`,
            ToastStatus.Error
          );
        }
        return false;
      }
    }

    return false;
  }

  public validateTel(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      if (control.value.length < 11) {
        return { telephone: true };
      }

      return null;
    };
  }

  //   public validateCEP(): ValidatorFn {
  //     return (control: AbstractControl): ValidationErrors | null => {
  //       if (!control.value) {
  //         return null;
  //       }

  //       if (control.value.length < 9) {
  //         return { cep: true };
  //       }

  //       return null;
  //     };
  //   }

  public validateCPF(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }

      const cpf = control.value.replace(/\D/g, '');

      let soma: number = 0;
      let resto: number;

      const cpfs = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
      ];

      if (cpfs.includes(cpf)) {
        return of({ cpf: true });
      }

      for (let index = 1; index <= 9; index++) {
        soma += parseInt(cpf.substring(index - 1, index)) * (11 - index);
      }

      resto = (soma * 10) % 11;
      resto = resto === 10 || resto === 11 ? 0 : resto;

      if (resto !== parseInt(cpf.substring(9, 10))) {
        return of({ cpf: true });
      }

      soma = 0;

      for (let index = 1; index <= 10; index++) {
        soma += parseInt(cpf.substring(index - 1, index)) * (12 - index);
      }

      resto = (soma * 10) % 11;
      resto = resto === 10 || resto === 11 ? 0 : resto;

      if (resto !== parseInt(cpf.substring(10, 11))) {
        return of({ cpf: true });
      }

      return of(null);
    };
  }

  setPart1(data: any) {
    this.part1Data = data;
    this.utilsService.setStorage('franchisee_part1_data', JSON.stringify(data));
  }
  
  getPart1() {
    if (!this.part1Data) {
      const storedData = this.utilsService.getStorage('franchisee_part1_data');
      if (storedData) {
        try {
          this.part1Data = JSON.parse(storedData);
        } catch (error) {
          this.part1Data = null;
        }
      }
    }
    return this.part1Data;
  }
  
  clearFormData() {
    this.part1Data = null;
    this.utilsService.removeStorage('franchisee_part1_data');
  }



  //   public validateDate(): ValidatorFn {
  //     return (control: AbstractControl): ValidationErrors | null => {
  //       const data = control.value;

  //       if (!data) {
  //         return null;
  //       }

  //       if (data.length !== 10) {
  //         return { birthDate: true };
  //       }

  //       const [day, month, year] = data.split('/').map(Number);

  //       if (isNaN(day) || isNaN(month) || isNaN(year)) {
  //         return { birthDate: true };
  //       }

  //       const birthDate = new Date(year, month - 1, day);

  //       if (
  //         isNaN(birthDate.getTime()) ||
  //         !this.validDate(day, month, year) ||
  //         this.calculateAge(birthDate) < 16 ||
  //         this.calculateAge(birthDate) > 100
  //       ) {
  //         return { birthDate: true };
  //       }

  //       return null;
  //     };
  //   }

  //   private validDate(day: number, month: number, year: number): boolean {
  //     const currentYear = new Date().getFullYear();
  //     if (year < 1900 || year > currentYear) {
  //       return false;
  //     }

  //     if (month < 1 || month > 12) {
  //       return false;
  //     }

  //     const monthDay = new Date(year, month, 0).getDate();
  //     if (day < 1 || day > monthDay) {
  //       return false;
  //     }

  //     return true;
  //   }

  //   private calculateAge(data: Date): number {
  //     const today = new Date();
  //     const birth = new Date(data);
  //     const age = today.getFullYear() - birth.getFullYear();

  //     return today.setFullYear(2000) < birth.setFullYear(2000) ? age - 1 : age;
  //   }

  //   public validatePassword(): ValidatorFn {
  //     return (control: AbstractControl): ValidationErrors | null => {
  //       const password = control.value;

  //       if (password && (password.length < 5 || password.length > 30)) {
  //         return { password: true };
  //       }

  //       const uppercase = /[A-Z]/.test(password);
  //       const lowercase = /[a-z]/.test(password);
  //       const number = /[0-9]/.test(password);

  //       if (!(uppercase && lowercase && number)) {
  //         return { password: true };
  //       }

  //       return null;
  //     };
  //   }

  //   public validateVality(): ValidatorFn {
  //     return (control: AbstractControl): ValidationErrors | null => {
  //       const data = control.value;
  //       if (!data) {
  //         return null;
  //       }

  //       const [month, year] = data.split('/');
  //       const numericYear =
  //         Number(year) > 40 ? 1900 + Number(year) : 2000 + Number(year);

  //       const day = new Date();
  //       const validity = new Date(numericYear, Number(month) - 1, 1);

  //       if (day.getTime() > validity.getTime()) {
  //         return { validity: true };
  //       } else {
  //         return null;
  //       }
  //     };
  //   }
}
